<template>
  <div class="h-auto">
    <v-card
      v-if="showCard"
      width="100%"
      flat
      class="mx-auto"
      color="amber lighten-5"
      min-height="56px"
    >
      <v-card-text class="px-0 py-0">
        <v-list-item one-line class="d-flex align-center">
          <v-list-item-content>
            <div class="text-overline">
              {{ isEmptyExternalBroker ? "Sin " : "" }}Broker Externo
            </div>
          </v-list-item-content>
          <v-btn
            color="amber lighten-5"
            depressed
            small
            @click="showFormBrokerExternal = true"
          >
            {{ isEmptyExternalBroker ? "Agregar" : "Cambiar" }}
          </v-btn>
        </v-list-item>
        <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0" v-if="external_broker.name">
            <v-list-item>
              <v-list-item-avatar class="mr-0">
                <v-icon>
                  mdi-account
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{
                  external_broker.name
                }}</v-list-item-title>
                <v-list-item-subtitle>Nombre</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <!-- Email -->
          <v-col class="ma-0 pa-0" v-if="external_broker.email">
            <v-menu
              open-on-hover
              offset-y
              top
              color="primary"
              close-delay="500"
              open-delay="300"
              min-width="10"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs">
                  <v-list-item>
                    <v-list-item-avatar class="mr-0">
                      <v-icon>
                        mdi-email
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        external_broker.email
                      }}</v-list-item-title>
                      <v-list-item-subtitle>Email</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </template>
              <ToolTipContact
                type="email"
                :value="external_broker.email"
                :message="`Hola, ${external_broker.name}.`"
              />
            </v-menu>
          </v-col>
          <!-- Phone -->
          <v-col class="ma-0 pa-0" v-if="external_broker.phone">
            <v-menu
              open-on-hover
              offset-y
              top
              color="primary"
              close-delay="500"
              open-delay="300"
              min-width="10"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs">
                  <v-list-item>
                    <v-list-item-avatar class="mr-0">
                      <v-icon>
                        mdi-phone
                      </v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>{{
                        external_broker.phone
                      }}</v-list-item-title>
                      <v-list-item-subtitle>Celular</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </template>
              <ToolTipContact
                type="phone"
                :value="external_broker.phone"
                :message="`Hola, ${external_broker.name}.`"
              />
            </v-menu>
          </v-col>
          <!-- Inmo -->
          <v-col v-if="external_broker.real_estate_name">
            <v-list-item>
              <v-list-item-avatar class="mr-0">
                <v-icon>
                  mdi-office-building
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{
                  external_broker.real_estate_name
                }}</v-list-item-title>
                <v-list-item-subtitle>Inmobiliaria</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showFormBrokerExternal" max-width="620px">
      <v-toolbar dense class="white--text" flat color="primary">
        <v-toolbar-title class="font-weight-regular my-4"
          >Cambiar Broker Externo
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="showFormBrokerExternal = false"
          id="close-lead-modal"
          class="white--text"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card style=" background: #FEF9F1;">
        <v-col class="pa-0 ma-0" height="100%" transition="slide-x-transition">
          <external-broker-search-and-registration
            transition="slide-x-transition"
            ref="externalBrokerSearch"
            typeComponent="Lead"
            @setValidate="value => (validateExternalBroker = value)"
            @setData="value => (dataByExternalBroker = value)"
          />
        </v-col>
        <v-card-actions class="justify-end">
          <v-btn
            color="blue darken-1"
            text
            @click="showFormBrokerExternal = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="!enableButtonSave"
            :loading="loadingChange"
            @click="onSaveNewBrokerExternal"
          >
            Cambiar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ToolTipContact from "./toolTipContact.vue";
import { mapActions } from "vuex";
export default {
  components: {
    ToolTipContact,
    ExternalBrokerSearchAndRegistration: () =>
      import(
        "@/components/external-broker/ExternalBrokerSearchAndRegistration.vue"
      )
  },
  name: "brexDataBanner",
  props: {
    external_broker: {
      type: Object,
      required: true
    },
    showCard: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      showFormBrokerExternal: false,
      validateExternalBroker: false,
      showFormBrokerExternalNew: false,
      dataByExternalBroker: null,
      loadingSave: false,
      loadingChange: false
    };
  },
  watch: {
    showFormBrokerExternal(newValue) {
      if (!newValue) {
        this.$refs.externalBrokerSearch.clearForm();
      }
    }
  },
  computed: {
    enableButtonSave() {
      if (!this.dataByExternalBroker?.name) return false;
      return true;
    },
    isEmptyExternalBroker() {
      return Object.keys(this.external_broker).length === 0;
    }
  },
  methods: {
    ...mapActions({
      createBrex: "brex/createBrex",
      fetchActualLead: "leads/fetchActualLead"
    }),
    async onSaveNewBrokerExternal() {
      const responseValidate = this.$refs.externalBrokerSearch.validate();
      if (responseValidate) {
        this.loadingChange = true;
        let contact_external_broker_id = null;
        // Es un broker ya existente
        if (this.dataByExternalBroker._id) {
          contact_external_broker_id = this.dataByExternalBroker._id;
        } else {
          const response = await this.sendCreateExternalBroker();
          contact_external_broker_id = response.contact_id;
        }
        this.$emit("changeNewExternalBroker", contact_external_broker_id);
        this.loadingChange = false;
      }
    },
    async sendCreateExternalBroker() {
      return await this.createBrex(
        this.generateDataSave(this.dataByExternalBroker)
      );
    },
    generateDataSave(data) {
      return {
        name: data.name.trim(),
        email: data.email.replace(/ /g, ""),
        phone: (data.countrySelectedCode + data.phone).replace(/ /g, ""),
        type: "external",
        status: 1,
        real_estate_name: data.real_estate_name
      };
    }
  }
};
</script>
